// Project countries query — the project's whitelisted country ISO codes (the
// `project_countries` allow-list the administrativeAreas composite FK checks against). Feeds the
// administrative areas' parent field its country rows (the navigator's root), so an EMPTY project
// (empty tree, non-empty whitelist) can still create its first root; the site form's
// country field and the wizard's default country (each row's `is_default`) read it too. One
// cached query keyed by project (member-read).

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiClient } from '../lib/apiClient.js';
import type { ProjectCountriesResponse, ProjectCountry } from '@ems-app/schemas/projects/countries';

export const projectCountriesKeys = {
  all: (projectId: string) => ['project-countries', projectId] as const,
};

export async function fetchProjectCountries(projectId: string): Promise<ProjectCountry[]> {
  const { data } = await apiClient.get<ProjectCountriesResponse>(`/projects/${projectId}/countries`);
  return data.items;
}

export function useProjectCountries(projectId: string): UseQueryResult<ProjectCountry[], Error> {
  return useQuery({
    queryKey: projectCountriesKeys.all(projectId),
    queryFn: () => fetchProjectCountries(projectId),
    enabled: projectId.length > 0,
  });
}
